module.exports = __webpack_public_path__ + "img/countesse_perverse_tablet.74b78044.jpg";